import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  constructor(private titleService: Title, private metaService: Meta) {}

  updateSeo(
    title = 'Golf.ai - AI-Powered Golf Caddie & Interactive Scorecards', 
    description = "Transform your game with Golf.ai's Ai Caddie instructions and dynamic PGA & LIV Ai scorecards. Watch, play, and improve on the course.", 
    url = 'https://golf.ai/'
    ) {
    this.titleService.setTitle(title);

    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:url', content: url });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
  }
}
